<script setup lang="ts">
interface FavouritesViewModel {
  count?: number;
  items?: Array<{
    title?: string;
    description?: string;
    favouritesId?: string;
    path?: string;
  }>;
  setActiveTab?: (tab: string) => void;
}

const props = defineProps<FavouritesViewModel>();

function handleClick(
  item: { title?: string; description?: string; favouritesId?: string; path?: string } | null | undefined
) {
  if (!item || !item.title) return;
  if (item.title.toLowerCase().includes('like for like')) {
    if (props.setActiveTab) {
      props.setActiveTab('LikeForLikeReport');
    }
  } else if (item.path && item.favouritesId) {
    window.open(`${item.path}?f=${item.favouritesId}`, '_blank');
  }
}
</script>

<template>
  <div class="dashboard-favourites bg-white" v-if="props.items">
    <div class="dashboard-subtitle pt-5 pl-8 font-500">
      Find how your CX is performing with our pre-populated reports
    </div>
    <div class="dashboard-favourites-items pt-5 pb-10" v-if="props.items.length > 0">
      <div
        @click="handleClick(item)"
        class="dashboard-favourites-item"
        v-for="(item, index) in props.items"
        :key="index"
      >
        <svg
          width="30"
          height="22"
          viewBox="0 0 30 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="dashboard-favourites-icon"
          v-if="!item!.title!.toLowerCase().includes('like for like')"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.13998 4.26424C7.13998 3.95978 7.13834 3.62395 7.45326 3.44681L13.3936 0.881429C14.309 0.366528 15.4481 0.373386 16.3566 0.899267L22.5546 3.68847C22.8641 3.86768 22.86 4.19974 22.86 4.50136V8.84538C23.0803 8.91099 23.2941 9.00239 23.4965 9.11955L29.6945 11.9088C30.0041 12.088 30 12.3832 30 12.7216L29.993 17.9512C29.993 17.9837 29.9976 17.92 29.993 17.9512C29.993 18.2187 29.906 18.4893 29.6498 18.6352L24.0941 21.0136C22.9414 21.6702 21.5003 21.6614 20.3565 20.991L15.1607 18.7543L9.81416 21.0136C8.66144 21.6702 7.22037 21.6614 6.07652 20.991L0.342367 18.4388C0.074477 18.2818 0 17.9778 0 17.7112L2.56971e-09 12.4845C8.54686e-06 12.1689 -0.00163972 11.8442 0.313281 11.6671L6.2536 9.10171C6.53257 8.9448 6.83231 8.83634 7.13998 8.77626V4.26424ZM14.392 6.24047L9.21951 4.0449L14.1265 2.06076C14.5842 1.80331 15.1538 1.80674 15.608 2.06968L20.7805 4.26525L15.8735 6.24939C15.4158 6.50684 14.8462 6.50341 14.392 6.24047ZM21.4199 8.77626V5.49717L16.6064 7.42872C15.691 7.94362 14.5519 7.93676 13.6434 7.41088L8.58007 5.27848V8.84538C8.80034 8.91099 9.01419 9.00239 9.2166 9.11955L14.7981 11.5519L20.5336 9.10171C20.8125 8.9448 21.1123 8.83634 21.4199 8.77626ZM23.7464 15.649L28.5599 13.7175V17.6592L23.3544 19.8381C22.6628 20.232 21.7981 20.2268 21.1118 19.8246L15.72 17.473V13.4988L20.7834 15.6312C21.6919 16.157 22.831 16.1639 23.7464 15.649ZM14.28 17.6592V13.7175L9.46644 15.649C8.55105 16.1639 7.41192 16.157 6.50345 15.6312L1.44009 13.4988V17.473L6.83188 19.8246C7.51819 20.2268 8.38283 20.232 9.07447 19.8381L14.28 17.6592ZM7.25202 14.4608L2.07954 12.2652L6.98654 10.281C7.44423 10.0236 8.0138 10.027 8.46803 10.29L13.6405 12.4855L8.73351 14.4697C8.27582 14.7271 7.70625 14.7237 7.25202 14.4608ZM16.3595 12.2652L21.532 14.4608C21.9862 14.7237 22.5558 14.7271 23.0135 14.4697L27.9205 12.4855L22.748 10.29C22.2938 10.027 21.7242 10.0236 21.2665 10.281L16.3595 12.2652Z"
            fill="#4F4F4F"
          />
        </svg>
        <svg
          width="30"
          height="22"
          viewBox="0 0 23 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="dashboard-favourites-icon"
          v-if="item!.title!.toLowerCase().includes('like for like')"
        >
          <path
            d="M21.3571 0H1.64286C0.736049 0 0 0.784047 0 1.75V19.25C0 20.216 0.736049 21 1.64286 21H21.3571C22.264 21 23 20.216 23 19.25V1.75C23 0.784047 22.264 0 21.3571 0ZM15 5V9H8V5H15ZM15 10L15 14H8V10H15ZM1.64286 5H7L7 9H1.64286V5ZM1.64286 10H7V14H1.64286L1.64286 10ZM1.64286 19.25L1.64286 15H7V19.25H1.64286ZM8 19.25L8 15H15L15 19.25H8ZM21.3571 19.25H16L16 15H21.3571L21.3571 19.25ZM21.3571 14H16L16 10H21.3571L21.3571 14ZM21.3571 9H16L16 5H21.3571L21.3571 9Z"
            fill="#4A4A4A"
          />
        </svg>

        <div class="dashboard-favourites-content">
          <div>{{ item.title }}</div>
          <div class="dashboard-favourites-description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.dashboard-favourites {
  display: flex;
  flex-direction: column;

  .dashboard-favourites-items {
    display: flex;
    gap: 30px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    .dashboard-favourites-item {
      background: #f7f7f7;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      width: 420px;
      height: 110px;
      padding: 30px;
      cursor: pointer;

      .dashboard-favourites-icon {
        display: inline-block;
        vertical-align: top;
        margin-top: 4px;
      }

      .dashboard-favourites-content {
        margin-left: 16px;
        display: inline-block;
        max-width: 80%;
      }

      .dashboard-favourites-description {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>
